<template>
  <div class="main">
    <div class="recruiting1">
      <div
        :class="{ active: applicationStatus == item.applicationStatus, common: applicationStatus != item.applicationStatus }"
        v-for="(item, index) in chooseTypes" :key="index" @click="switchStatus(item.applicationStatus)">
        {{ item.text }}
      </div>
    </div>
    <div class="recruiting2">
      <el-col :span="4">
        <el-select v-model="targetType" placeholder="应聘岗位" @change="getCompanyPcCandidateList">
          <el-option label="全部" value="">
          </el-option>
          <el-option label="岗位" value="0">
          </el-option>
          <el-option label="项目" value="1">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" :offset="1">
        <el-select v-model="educated" placeholder="学历" @change="getCompanyPcCandidateList">
          <el-option v-for="(item, index) in educatedList" :key="index" :label="item.paramName" :value="item.paramName">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" :offset="1">
        <el-select v-model="jobYear" placeholder="工作经验" @change="getCompanyPcCandidateList">
          <el-option v-for="(item, index) in experience_required" :key="index" :label="item.paramName"
            :value="item.paramName">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" :offset="1">
        <el-select v-model="age" placeholder="年龄" @change="getCompanyPcCandidateList">
          <el-option v-for="(item, index) in age_type" :key="index" :label="item.paramName" :value="item.paramName">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" :offset="1">
        <el-checkbox v-model="newUnRead" @change="getCompanyPcCandidateList">新招呼</el-checkbox>
        <el-checkbox v-model="promoterByMe" @change="getCompanyPcCandidateList">我发起</el-checkbox>
      </el-col>
      <el-col :span="1" :offset="1">
        <div class="reset" @click="resetData">重置</div>
      </el-col>
    </div>
    <el-table :data="tableData" class="table">
      <!-- <el-table-column type="selection" width="55"/> -->
      <el-table-column label="牛人" width="120" align="center">
        <template slot-scope="scope">
          <div class="tableName">
            <div>
              <img :src="scope.row.photo" alt="">
            </div>
            <div>{{ scope.row.name }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="基本信息" width="180" show-overflow-tooltip align="center">
        <template slot-scope="scope">
          <div class="tableInfo ellipsis" style="text-align: center;width: 160px;">
            <span>{{ scope.row.educated }}</span>·<span>{{ scope.row.age }}岁</span>·<span>{{ scope.row.jobYear
              }}年</span>·<span>{{ scope.row.expectedSalary }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="resName" label="应聘岗位" show-overflow-tooltip align="center">
        <template slot-scope="scope">
         <span @click="checkPosition(scope.row)" style="color: #0051AA; padding-right: 10px;cursor: pointer;">
             {{ scope.row.resName }}
         </span>
        </template>
      </el-table-column>
      <el-table-column prop="newExperience" label="最近工作经历" show-overflow-tooltip align="center">
      </el-table-column>
      <el-table-column prop="college" label="教育经历" show-overflow-tooltip align="center">
      </el-table-column>
      <!--<el-table-column prop="positionId" label="岗位id" show-overflow-tooltip align="center">
      </el-table-column>-->
      <el-table-column prop="applicationTime" label="投递时间" show-overflow-tooltip align="center">
      </el-table-column>
      <el-table-column label="录取状态" show-overflow-tooltip align="center">
        <template slot-scope="scope">
          <div class="tabstatus" style="text-align: center;">
            <span>{{ scope.row.status == 0 ? '已报名' : (scope.row.status == 1 ? '未录取' : scope.row.status == 2 ? '已录取' : '已结束') }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="200" align="center">
        <template slot-scope="scope">
          <div class="setButton">
            <!--<span @click="checkResume(scope.row)"
              style="color: #0051AA; padding-right: 10px;cursor: pointer;">查看简历</span>-->
            <span @click="checkResume(scope.row)"
                    :style="{ color: '#0051AA', paddingRight: '10px', cursor: 'pointer' }"
                    v-if="scope.row.flag !== 9">查看简历</span>
            <span v-else @click="checkResume(scope.row)"  :style="{ color: '#0051AA', paddingRight: '10px', cursor: 'pointer' }">已查看</span>
            <span @click="goChat(scope.row)" style="color: #0051AA;cursor: pointer;">
              沟通
              <span v-if="scope.row.unReadNum" class="unRead">{{ scope.row.unReadNum }}</span>
            </span>
            <el-dropdown @command="showList" v-if="scope.row.status == '0'">
              <span style="color: #2661E1; cursor: pointer;padding-left: 10px;">编辑</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{ memberApplicationId: scope.row.memberApplicationId, examineStatus: 0 }">合适</el-dropdown-item>
                <el-dropdown-item
                  :command="{ memberApplicationId: scope.row.memberApplicationId, examineStatus: 1 }">不合适</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer">
      <div>共{{ total }}个职位</div>
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageNum"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>



    <el-dialog title="查看简历" :visible.sync="show" >
      <!-- <el-form :model="resumeForm" class="form1" ref="resumeForm" label-width="70px">
        <el-form-item label="名字">
          <el-input v-model="resumeForm.name" :disabled="true" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="resumeForm.phone" :disabled="true" />
        </el-form-item>
        <el-form-item label="性别">
          <el-input v-model="resumeForm.sex" :disabled="true" />
        </el-form-item>
        <el-form-item label="年龄">
          <el-input v-model="resumeForm.age" :disabled="true" />
        </el-form-item>
        <el-form-item label="学历">
          <el-input v-model="resumeForm.educated" :disabled="true" />
        </el-form-item>
        <el-form-item label="工作年限">
          <el-input v-model="resumeForm.jobYear" :disabled="true" />
        </el-form-item>
        <el-form-item label="期望薪资">
          <el-input v-model="resumeForm.expectedSalary" :disabled="true" />
        </el-form-item>
        <el-form-item label="毕业院校">
          <el-input v-model="resumeForm.college" :disabled="true" />
        </el-form-item>
        <el-form-item label="应聘岗位">
          <el-input v-model="resumeForm.resName" :disabled="true" />
        </el-form-item>
        <el-form-item label="工作经验">
          <div style="    background-color: #F5F7FA;
    border-color: #E4E7ED;padding: 8px;line-height: 1.5;    color: #C0C4CC;">{{ resumeForm.newExperience }}</div>
        </el-form-item>
      </el-form> -->
      <el-button @click="getPdf(resumeForm.name+'个人简历')">
        下载简历
      </el-button>
      <div style="padding: 10px;"  id="pdfDom">

      <el-descriptions title="基本信息" :column="3" border>
        <el-descriptions-item label="姓名">{{ resumeForm.name }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{ resumeForm.sex }}</el-descriptions-item>
        <el-descriptions-item label="照片">
          <image-preview :src="resumeForm.photo" :width="67" :height="67" />
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="" :column="2" border>
        <el-descriptions-item label="出生日期">{{ resumeForm.birthDate }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ resumeForm.phone }}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{ resumeForm.email }}</el-descriptions-item>

        <el-descriptions-item label="身份">{{ resumeForm.identity }}</el-descriptions-item>

        <el-descriptions-item label="毕业学校">{{ resumeForm.college }}</el-descriptions-item>
        <el-descriptions-item label="学历">{{ resumeForm.educated }}</el-descriptions-item>

        <el-descriptions-item label="入学时间">{{ resumeForm.collegeDate }}</el-descriptions-item>
        <el-descriptions-item label="工作经验">{{ resumeForm.jobYear }}年</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class" label="简述信息">{{ resumeForm.briefly
          }}</el-descriptions-item>

      </el-descriptions>
      <el-descriptions title="求职意向" :column="1" border>
        <el-descriptions-item label-class-name="experience_class"
          label="期望区域">{{ resumeForm.province }}-{{ resumeForm.city }}-{{ resumeForm.area }}</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class"
          label="期望行业">{{ resumeForm.positionOneName }}—{{ resumeForm.positionTypeName }}</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class"
          label="期望薪资">{{ resumeForm.expectedSalary }}</el-descriptions-item>

        <el-descriptions-item label-class-name="experience_class"
          label="工作时间">{{ resumeForm.workWeekend }}</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class"
          label="工作时段">{{ resumeForm.workTime }}</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class"
          label="每周工作">{{ resumeForm.everyWeek }}</el-descriptions-item>
      </el-descriptions>
      <!-- 工作经验 -->
      <el-descriptions title="项目经验" v-if="resumeForm.memberProjectExperienceList" :column="1" border />

      <el-descriptions v-for="(item, index) in resumeForm.memberProjectExperienceList" :key="index" title="" :column="1"
        border>
        <el-descriptions-item label-class-name="experience_class"
          label="项目名">{{ item.projectName }}</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class"
          label="时间">{{ item.beginTime }}——{{ item.endTime }}</el-descriptions-item>
        <el-descriptions-item label-class-name="experience_class" label="责任描述">{{ item.dutyInfo }}</el-descriptions-item>
      </el-descriptions>

      <!-- 技能证书 -->
      <el-descriptions title="技能证书" v-if="resumeForm.resumeCertificateList" :column="1" border />

      <el-descriptions v-for="(item, index) in resumeForm.resumeCertificateList" :key="index" title="" :column="1"
        border>
        <!-- <el-descriptions-item label-class-name="experience_class" label="技能">{{ item.skillType }}</el-descriptions-item> -->
        <el-descriptions-item label-class-name="experience_class"
          label="证书">{{ item.certificateType }}</el-descriptions-item>
          <el-descriptions-item label-class-name="experience_class" label="证书图片">
            <image-preview v-for="(ite, i) in item.certificateImg" :key="i" :src="ite" :width="67" :height="67" />
          </el-descriptions-item>
      </el-descriptions>
    </div>

    </el-dialog>


    <el-dialog title="查看岗位" :visible="showGangwei" @close="cancel" width="700px" append-to-body>

      <el-descriptions title="" :column="1" border>
        <el-descriptions-item label-class-name="my-label" label="职位名称">{{ form.positionTitle }}</el-descriptions-item>
        <!-- <el-descriptions-item label="发布人">{{ form.companyUserName }}</el-descriptions-item> -->
        <el-descriptions-item label="联系电话">{{ form.contactPhone }}</el-descriptions-item>
        <!-- <el-descriptions-item label="邮箱">{{form.email}}</el-descriptions-item> -->
        <!-- <el-descriptions-item label="所属企业">{{ form.companyName }}</el-descriptions-item> -->

        <el-descriptions-item label="职位类型">{{ form.positionTypeName }} /
          {{ form.positionTypeSecondaryName }}</el-descriptions-item>
        <el-descriptions-item label="职位偏好">{{ form.positionWorkTypeName }}</el-descriptions-item>
        <el-descriptions-item label="工作地址">{{ form.provinceName }}/{{ form.cityName }}/{{ form.areaName }}
          {{ form.workAddress }}</el-descriptions-item>

        <el-descriptions-item label="职位标签">
          <el-tag v-for="item in tags" :key="item" effect="plain" style="margin-left: 10px">{{ item }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="职位描述">
          <div style="word-break: break-all;white-space: pre-line;" v-html="form.positionDescribe"></div>
        </el-descriptions-item>
        <el-descriptions-item label="职位要求">
          <div style="word-break: break-all;white-space: pre-line;" v-html="form.personnelRequire"></div>
        </el-descriptions-item>
        <el-descriptions-item label="招聘人数">{{ form.recruitNumber }}</el-descriptions-item>

        <el-descriptions-item label="薪资范围"> {{
          (form.salaryBegin ? form.salaryBegin : '') + (form.salaryEnd ? '-' + form.salaryEnd : '') + form.salaryUnit
          }}</el-descriptions-item>
        <el-descriptions-item label="结算方式">{{ form.settlementMethod }}</el-descriptions-item>

        <el-descriptions-item label="福利提成">
          <div style="word-break: break-all;white-space: pre-line;" v-html="form.welfareCommission"></div>
        </el-descriptions-item>
        <el-descriptions-item label="工作周期">{{ form.workCycle == '0' ? '兼职' : '全职' }}</el-descriptions-item>
        <el-descriptions-item label="每周工作天数">{{ form.weekWorkDay }}</el-descriptions-item>
        <el-descriptions-item label="工作时间">{{ form.workTime }}</el-descriptions-item>
        <el-descriptions-item label="工作时段">{{ form.workPeriod }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      chooseTypes: [{
        text: '全部',
        applicationStatus: "-1"
      }, {
        text: '已报名',
        applicationStatus: "0"
      }, {
        text: '未录取',
        applicationStatus: "1"
      }, {
        text: '已录取',
        applicationStatus: "2"
      }, {
        text: '已结束',
        applicationStatus: "3"
      }],
      showGangwei:false,
      newUnRead: false,
      promoterByMe: false,
      targetType: '',
      pageNum: 1,
      active: "0",
      total: 10,
      checked: false,
      experience_required: [],
      age_type: [],
      educatedList: [],
      tableData: [],
      jobYear: '',
      educated: '',
      age: '',
      positionId:'',
      memberInfo: {},
      applicationStatus: '-1',
      show: false,
      resumeForm: {},
      form: {
        positionTypeId: null,
        positionTypeIdSecondary: null,
        positionType: [],
        positionTitle: null,
        positionWorkTypeId: '',
        workCycle: null,
        weekWorkDay: null,
        workTime: '',
        workPeriod: [],
        provinceName: null,
        cityName: null,
        areaName: null,
        workAddress: null,
        longitude: null,
        latitude: null,
        salaryBegin: null,
        salaryEnd: null,
        salaryUnit: null,
        contactPhone: null,
        positionDescribe: '',
        recruitNumber: null,
        settlementMethod: '',
        personnelRequire: '',
        welfareCommission: '',
        positionTag: [],
        region: [],
      },
    }
  },
  mounted() {
    this.getDictParamList()
    this.getCompanyPcCandidateList()
  },

  methods: {
    downloadFile(){
      // const fileUrl = 
    },

    showList(id) {
      let text = id.examineStatus == 0 ? '录取' : '拒绝'
      this.$alert(`是否${text}该候选人`, '用户确认', {
        confirmButtonText: '确定',
        callback: action => {
          if (action == 'confirm') {
            this.$post('/api/company/position/memberApplicationExamine', {
              ...id
            }).then(res => {
              this.$message({
                type: 'info',
                message: `该候选人状态已修改`
              });
              this.getCompanyPcCandidateList()
            })
          }
        }
      });
    },
    handleCurrentChange(value) {
      this.pageNum = value
      this.getCompanyPcCandidateList()
    },
    checkResume(row) {
      // console.log(row);
      this.show = true
      // this.resumeForm = row
      this.getMemberResumeInfo(row.resumeId)
    },
    //查看岗位详情
    checkPosition(row){
      this.showGangwei=true;
      this.getCompanyPositionInfo(row.positionId)
    },
    cancel(){
      this.showGangwei = false
    },
    getCompanyPositionInfo(positionId){
      this.$get("/api/company/position/getCompanyPositionInfo", {
        positionId,
      }).then((res) => {
          for (let i in res.data) {
            this.form[i] = res.data[i] !== null ? res.data[i] : ''
          }
          this.form.positionDescribe = res.data.positionDescribe || ''
          this.form.personnelRequire = res.data.personnelRequire || ''
          this.form.welfareCommission = res.data.welfareCommission || ''
          this.form.positionType = [res.data.positionTypeId, res.data.positionTypeIdSecondary]
          this.form.workPeriod = res.data.workPeriod ? res.data.workPeriod.split(',') : ''
          this.form.positionTag = res.data.positionTag ? res.data.positionTag.split(',') : []
          this.form.positionWorkTypeId = res.data.positionWorkTypeId ? res.data.positionWorkTypeId.split(',') : []
          this.form.region = []
          this.form.region[0] = res.data.provinceName ? res.data.provinceName.replace('市', '') : ''
          this.form.region[1] = res.data.cityName
          this.form.region[2] = res.data.areaName
      });
    },
    resetData() {
      // console.log(11)
      this.applicationStatus = '-1'
      this.targetType = ''
      this.jobYear = ''
      this.educated = ''
      this.age = ''
      this.newUnRead = ''
      this.promoterByMe = ''
      this.positionId = ''
      this.getCompanyPcCandidateList()
    },
    switchStatus(status) {
      this.applicationStatus = status
      this.getCompanyPcCandidateList()
    },
    goChat(row) {
      this.$cookie.set("chatId", row.chatId);
      this.$cookie.set("JresumeId", row.resumeId);
      this.$router.push({ path: "/communicate" });
    },
    getMemberResumeInfo(resumeId) {
      console.log(resumeId);
      this.$get('/api/company/resume/getCompanyResumeInfo', {
        resumeId
      }).then(res => {
        if (res.data.resumeCertificateList) {
          res.data.resumeCertificateList.map(item => {
            if (item.certificateImg) {
              item.certificateImg = item.certificateImg.split(',')
            }
          })
        }
        this.resumeForm = res.data
      })
    },
    getCompanyPcCandidateList() {
      this.$get('/api/company/position/getCompanyPcCandidateList', {
        applicationStatus: this.applicationStatus == '-1' ? '' : this.applicationStatus,
        targetType: this.targetType,
        jobYear: this.jobYear,
        educated: this.educated,
        age: this.age,
        positionId:this.positionId,
        newUnRead: this.newUnRead ? '1' : '0',
        promoterByMe: this.promoterByMe ? '1' : '0',
        pageNum: this.pageNum,
        pageSize: 10
      }).then(res => {
        this.tableData = res.data.list
        console.log(this.tableData)
        this.total = res.data.total
      })
    },
    getDictParamList() {
      this.$get("/api/common/getDictParamList", {
        paramType: 'experience_required',
      }).then((res) => {
        this.experience_required = res.data
      });
      this.$get("/api/common/getDictParamList", {
        paramType: 'age_type',
      }).then((res) => {
        this.age_type = res.data
      });
      this.$get("/api/common/getDictParamList", {
        paramType: 'educated',
      }).then((res) => {
        this.educatedList = res.data
      });
    },
  },
}
</script>
<style scoped>
.main {
  padding: 30px;
}

.recruiting1 {
  display: flex;
}

.recruiting1>div {
  padding: 8px 20px;
  height: 22px;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
}

.common {
  color: #555555;
}

.active {
  background-color: #0051aa;
  color: #ffffff;
}

.recruiting2 {
  display: flex;
  align-items: center;
  width: auto;
  /* height: 50px; */
  padding: 10px 40px;
  margin-top: 20px;
  margin-bottom: 20px;
  background: #FFFFFF;
}

.reset {
  width: 28px;
  height: 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #000000;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
}

.reset:hover {
  color: #0051aa;
}

.tableName {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tableName>div:nth-of-type(1) {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  margin-right: 10px;
}

.tableName>div:nth-of-type(1)>img {
  width: 100%;
  /* 或者指定固定宽度 */
  height: 100%;
  /* 高度自动调整以保持图片比例 */
  object-fit: cover;
  /* 图片将被缩放并居中显示在容器内 */
  border-radius: 50%;
}

.tableInfo {
  height: 22px;
  font-family: PingFangSC-Regular, PingFangSC-Regular;
  font-weight: normal;
  font-size: 12px;
  color: #555555;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 10px;
  margin-bottom: 10px;
}

.table {
  width: 100%;
}

.footer {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.setButton {
  display: flex;
  align-items: center;
  /* justify-content: space-around; */
}

.unRead {
  width: 14px;
  height: 14px;
  text-align: center;
  line-height: 14px;
  color: #FFFFFF;
  font-size: 10px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  top: -6px;
  left: -6px;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style>
.experience_class {
  width: 120px;
}
</style>